<template>
  <teleport to="body">
    <div class="fixed top-4 right-4 z-50 space-y-2">
      <Toast
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :type="toast.type"
        :title="toast.title"
        :message="toast.message"
        :duration="0"
        :visible="true"
        @close="toastStore.removeToast(toast.id)"
      />
    </div>
  </teleport>
</template>

<script setup lang="ts">
import Toast from './Toast.vue'
import { useToastStore } from '@/stores/toast'

const toastStore = useToastStore()
</script> 